import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Drawer } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import logo from '@/assets/logo.png';
import CloseIcon from '@/assets/icon-close.svg?react';
import LogoutIcon from '@/comp/common/icons/LogoutIcon';
import HamburgerMenuIcon from '@/comp/common/icons/HamburgerMenuIcon';

import { DrawerGlobalStyles, MobileDrawerMenuContainer } from './MobileDrawerMenu.styles';
import { getNavItems, getTitle } from './MobileDrawerMenu.utils';
import { parseNavItem, signOutHandler } from '../StationPage.utils';

const MobileDrawerMenu = observer(() => {
  const { stationStore } = useStores();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { userStore } = useStores();

  const navItems = getNavItems(t, stationStore.stationTier);
  const title = getTitle(location.pathname, navItems);

  useEffect(() => {
    stationStore.setUseMockData(location.pathname.includes('/tab'));
    if (isDrawerOpen) setIsDrawerOpen(false);
  }, [location.pathname]);

  const toggleDrawer = (value: boolean) => () => {
    setIsDrawerOpen(value);
  };

  return (
    <MobileDrawerMenuContainer>
      <div className="title-container">
        <img src={logo} className="logo" alt={t(`Eco plant's logo`)} width={22} height={22} />
        {title && <span className="title">{title}</span>}
      </div>
      <HamburgerMenuIcon onClick={toggleDrawer(true)} className="hamburger-menu-icon" />
      <Drawer
        closable={false}
        onClose={toggleDrawer(false)}
        open={isDrawerOpen}
        width={'100%'}
        className="mobile-drawer-menu"
      >
        <div className="header">
          <CloseIcon onClick={toggleDrawer(false)} />
        </div>
        <div className="nav-items-container">
          {navItems.map((item, index) => (
            <div key={index} className="menu-item">
              {parseNavItem(item)}
            </div>
          ))}
          <div className="menu-item">
            <a onClick={signOutHandler(userStore, navigate)}>
              <LogoutIcon className="icon" />
              <span className="label">{t('Logout')}</span>
            </a>
          </div>
        </div>
      </Drawer>
      <DrawerGlobalStyles theme={undefined} />
    </MobileDrawerMenuContainer>
  );
});

export default MobileDrawerMenu;
